module.exports = __webpack_public_path__ + "img/promo-3.16097bd1.png";